import { ServiceModel, ServiceModelListItem } from "../../model";
import { Ajax, CrudApiBase } from "../infra";

/**
 * Provides CRUD access for Service Models
 */
export class ServiceModels extends CrudApiBase<ServiceModel, ServiceModelListItem> {

  /**
   * For NG1-dependency injection
   * @ignore
   */
  public static $inject = ["AjaxNg1"];

  /** Base URL for details etc. */
  protected baseUrl = "/v03/api/service-models";

  constructor(ajax: Ajax) {
    super(ajax);
  }
  /** Client-side (synchronous) method for getting a new blank item as bases for UI binding. */
  public getBlank(): ServiceModel {
    return {
      features: {},
      accounting: {
        targets: []
      },
      pricing: {},
      payments: {},
      branding: {},
      reporting: {},
      site: {}
    };
  }
}
